import Message from 'semantic-ui-react/dist/commonjs/collections/Message'
export default Message
